// extracted by mini-css-extract-plugin
export default {"wrapper":"Play_wrapper__sfF7D","inner":"Play_inner__srDcp","path":"Play_path__FI1kY","see-more":"Play_see-more__d+DW6"};